import { useModuleBEM, useTenantImages } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PageLoadingScreen } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarListLoading.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export interface CarListLoadingComponentProps extends PlatformComponentProps {
  isLoading?: boolean;
}

const COMPONENT_KEY = CoreCarsComponent.CarListLoading;

export const CarListLoading = ({
  isLoading,
  className,
  children,
}: CarListLoadingComponentProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const images = useTenantImages();

  return (
    <PageLoadingScreen
      isLoading={isLoading}
      backgroundImage={images.carLoadingImage}
      className={clsx(block, className)}
      text={t("core-cars.availabilityPage.loadingScreen.title")}
      subtitle={t("core-cars.availabilityPage.loadingScreen.subtitle")}
    >
      {children}
    </PageLoadingScreen>
  );
};
